module.exports = __webpack_public_path__ + "media/qmpz.e2fc74a3.mp4";